/* ------------------------------------------------------------------
   Orléa — LE PIED DU TIROIR DE FILTRES
   ------------------------------------------------------------------
   Flaunt ne rend AUCUNE action dans son tiroir : ni « voir le
   résultat », ni « tout effacer ». Le panneau restait vide aux trois
   quarts — le « tout cramé en haut à gauche » repéré par Simon.

   ⚠ POURQUOI DU JS ET PAS DU CSS : il faut CRÉER deux boutons qui
   n'existent pas, et le compteur doit suivre le filtrage en direct.

   ⚠ LE BOUTON « EFFACER » NE RÉINVENTE RIEN : le chemin de la page sans
   paramètre remet la collection à zéro.

   NOTE (2026-07-29) : depuis `orlea-filtrage.js`, le CONTENEUR du tiroir
   n'est plus détruit à chaque filtrage — seul le contenu du formulaire
   est remplacé. Le pied, qui est FRÈRE du formulaire, survit donc
   naturellement. L'observateur ci-dessous ne surveille plus que la zone
   des filtres (et non tout le document) : il met le compteur à jour, et
   recrée le pied dans le cas où Flaunt reprendrait la main (repli).
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var isFr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;

  function texteCompte(drawer) {
    // Le titre porte déjà « Filters (49 products) » : on réutilise ce
    // nombre plutôt que de le recalculer et risquer un écart.
    var h = drawer.querySelector('.filter_drawer_header h5');
    if (!h) return isFr ? 'Voir les résultats' : 'View results';
    var m = h.textContent.match(/(\d[\d\s,]*)/);
    if (!m) return isFr ? 'Voir les résultats' : 'View results';
    var n = m[1].trim();
    // « View 1 product », pas « 1 products ».
    var singulier = (parseInt(n.replace(/\D/g, ''), 10) === 1);
    if (isFr) return 'Voir ' + n + (singulier ? ' produit' : ' produits');
    return 'View ' + n + (singulier ? ' product' : ' products');
  }

  function cabler(drawer) {
    // Garde-fou par PRÉSENCE, pas par drapeau : le nœud peut être le même
    // mais son contenu remplacé.
    if (drawer.querySelector('.ofil-pied')) return;
    var zone = drawer.querySelector('.filter_drawer_filters_wrapper');
    if (!zone) return;

    var pied = document.createElement('div');
    pied.className = 'ofil-pied';

    var effacer = document.createElement('a');
    effacer.className = 'ofil-clear';
    effacer.textContent = isFr ? 'Tout effacer' : 'Clear all';
    effacer.href = window.location.pathname;

    // Voir les résultats — ferme le tiroir : le filtrage est déjà
    // appliqué à chaque clic.
    var voir = document.createElement('button');
    voir.type = 'button';
    voir.className = 'ofil-voir';
    voir.textContent = texteCompte(drawer);
    voir.addEventListener('click', function () {
      var croix = drawer.querySelector('.main_drawer_close');
      if (croix) croix.click();
    });

    pied.appendChild(effacer);
    pied.appendChild(voir);
    zone.parentNode.appendChild(pied);

    var maj = function () {
      voir.textContent = texteCompte(drawer);
      var actifs = drawer.querySelectorAll('.filter_input:checked').length;
      pied.dataset.oactifs = actifs > 0 ? 'oui' : 'non';
      // « Clear all » doit toujours pointer sur la collection nue, même
      // après que l'URL ait reçu des paramètres de filtre.
      effacer.href = window.location.pathname;
    };
    maj();

    // On observe la ZONE des filtres, pas tout le document : le compteur
    // et le titre changent à chaque filtrage. Observer `document.body`
    // faisait tourner ce callback à chaque image chargée de la grille.
    new MutationObserver(maj).observe(zone, {
      childList: true, subtree: true, characterData: true
    });
    // Le titre du tiroir (« Filters (N products) ») vit hors de la zone.
    var entete = drawer.querySelector('.filter_drawer_header');
    if (entete) {
      new MutationObserver(maj).observe(entete, {
        childList: true, subtree: true, characterData: true
      });
    }
  }

  function init() {
    document.querySelectorAll('.filter_drawer_wrapper').forEach(cabler);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Repli : si Flaunt reprend la main et remplace le tiroir entier, le
  // pied disparaît. On le recrée au prochain filtrage. `cabler` est
  // idempotent, donc l'appel est sans effet quand tout va bien.
  document.addEventListener('collection-page-update', function () {
    setTimeout(init, 120);
  });
})();
